import { render, staticRenderFns } from "./AdditionalRecords.vue?vue&type=template&id=c2bf90fe&scoped=true"
import script from "./AdditionalRecords.vue?vue&type=script&lang=js"
export * from "./AdditionalRecords.vue?vue&type=script&lang=js"
import style0 from "./AdditionalRecords.vue?vue&type=style&index=0&id=c2bf90fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bf90fe",
  null
  
)

export default component.exports